











import { Component, Vue, Prop } from "vue-property-decorator";
import { Asset } from "@foxone/api/src/models/wallet/mixin";
import AssetItem from "./AssetItem.vue";

@Component({
  components: {
    AssetItem
  }
})
class AssetsList extends Vue {
  @Prop({ type: String, default: "" }) filter!: string;

  @Prop() assets!: Asset[];

  get sortedAssets() {
    const assets = this.assets || [];
    return assets.concat().sort((b, a) => {
      return (
        Number(a.balance) * Number(a.price_usd) -
        Number(b.balance) * Number(b.price_usd)
      );
    });
  }

  get showAssets() {
    return this.sortedAssets.filter(asset => {
      const symbol = asset.symbol.toLowerCase();
      const filter = this.filter.toLowerCase();
      return symbol.includes(filter);
    });
  }
}
export default AssetsList;
